import { AppBar, Body, Button, PageLayout } from 'components/common';
import { useState } from 'react';

const IdCardGlyph: React.FC = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-5 w-5 shrink-0 text-base-txt-purple"
  >
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <circle cx="8.5" cy="11" r="2" />
    <path d="M13 10h5M13 14h3" />
  </svg>
);

const CheckMark: React.FC = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.4}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="mt-0.5 h-5 w-5 shrink-0 text-base-txt-purple"
  >
    <path d="M4 12.5 9.5 18 20 6" />
  </svg>
);

const PageUnderAgeYotiPrepare: React.FC = () => {
  const [imgState, setImgState] = useState<'loading' | 'loaded' | 'error'>('loading');

  // 인정 신분증은 국가 구분 없이 3종으로 통일: 신분증·여권·운전면허증.
  const docs = [brsc.age_prepare_type_national_id, brsc.age_prepare_type_passport, brsc.age_prepare_type_drivers_license];

  // 촬영 환경 체크리스트 3종(밝기·셀피·앞뒷면). 신분증 실물 항목은 위 "사용 가능한 신분증" 섹션과 겹쳐 제외.
  const checklist = [brsc.age_prepare_check_1, brsc.age_prepare_check_2, brsc.age_prepare_check_3];

  const handleStart = () => {
    Transition.showPage(Def.PAGE_UNDERAGE_FORM, { mode: 'yoti' });
  };

  return (
    <PageLayout>
      {/* 뒤로가기는 yoti 모드를 유지한 채 동의 페이지로. */}
      <AppBar onBack={() => Transition.showPage(Def.PAGE_UNDERAGE_DOCUMENT, { mode: 'yoti' })} />
      <Body className="flex flex-col pb-[60px]">
        <div className="no-scrollbar flex-1 overflow-y-auto px-6 pb-[60px]">
          <h1 className="mb-2 text-start typography-title-xl text-base-txt-primary">{brsc.age_prepare_title}</h1>

          {/* ID카드 이미지 — 타이틀 바로 아래, 가운데 정렬(preflight off라 img inline → block 명시해야 mx-auto 먹음). */}
          <div
            className={`mx-auto mt-6 aspect-[656/400] w-2/3 overflow-hidden rounded-2xl ${
              imgState === 'loaded' ? '' : 'bg-base-bg-subtle'
            }`}
          >
            <img
              src="/imgweb/underage/id_card.png"
              alt=""
              onLoad={() => setImgState('loaded')}
              onError={() => setImgState('error')}
              className={`block h-full w-full ${imgState === 'loaded' ? '' : 'opacity-0'}`}
            />
          </div>

          {/* "사용 가능한 신분증" 리스트 — 신분증·여권·운전면허증 3종. */}
          <h2 className="mb-3.5 mt-8 text-start typography-title-lg text-base-txt-primary">{brsc.age_prepare_id_title}</h2>
          <div className="flex flex-col gap-2.5">
            {docs.map((doc, index) => (
              <div key={index} className="flex items-center gap-2.5">
                <IdCardGlyph />
                <span className="typography-body-lg font-semibold text-base-txt-primary">{doc}</span>
              </div>
            ))}
          </div>

          {/* 촬영 전 확인 체크리스트. */}
          <h2 className="mb-3.5 mt-8 text-start typography-title-lg text-base-txt-primary">{brsc.age_prepare_checklist_title}</h2>
          <div className="rounded-xl bg-base-bg-subtle px-5 py-2">
            {checklist.map((item, index) => (
              <div key={index} className="flex items-start gap-3 py-2">
                <CheckMark />
                <span className="flex-1 typography-body-md leading-normal text-base-txt-primary">{item}</span>
              </div>
            ))}
          </div>

        </div>

        {/* 확인 게이트를 없애고 CTA 하나로 병합 — 버튼 자체가 "신분증 준비됨 → 시작" 의사표시. */}
        <div className="fixed bottom-0 left-0 right-0 flex justify-center p-6" style={{ paddingBottom: 'calc(var(--navigation-bar-height) + 16px)' }}>
          <Button
            style={{
              text: brsc.age_prepare_cta,
              color: 'btn-bg-secondary',
              fontColor: 'btn-txt-secondary',
            }}
            onClick={handleStart}
            className="max-w-[420px]"
          />
        </div>
      </Body>
    </PageLayout>
  );
};

export default PageUnderAgeYotiPrepare;
